<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="80%" :offset="0">
       <!-- Tab 切换 -->
      <div class="tab-container">
        <div class="tab" :class="!showInquiry?'active1':''" @click="showInquiry=false">报价信息</div>
        <div class="tab" :class="showInquiry?'active1':''" @click="showInquiry=true">询价详情</div>
      </div>
      <div class="main-area">
        <!-- 报价面板 -->
        <div v-show="!showInquiry">
          <div class="quote-card">
            <div class="flex-between" style="margin-bottom: 16px;">
              <h3 style="font-size: 20px; color: #142433;">报价方案 · {{ budget.resourceNameCn}}</h3>
              <span class="status-sent"><i class="fas fa-check-circle"></i>{{ item.isSend==1?"已发送报价给客户":item.isSend==1&&isOrder==1?"客户已购买":"已撤回报价"}}</span>
            </div>
            <!-- 成本/利润概览 -->
            <div class="cost-summary">
              <div class="summary-item">
                <span class="summary-label">成本</span>
                <span class="summary-value">¥{{budgetDetail.totalPrice}}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">报价</span>
                <span class="summary-value">¥{{budgetDetail.saleTotalPrice}}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">利润</span>
                <span class="profit-badge"><i class="fas fa-chart-line"></i> ¥{{( budgetDetail.saleTotalPrice-budgetDetail.totalPrice).toFixed(2) }}</span>
              </div>
            </div>
            <div class="action-group">
              <button class="btn btn-primary" @click="saveQutation" v-if="item.isSend!=1"><i class="fas fa-check-circle"></i> 保存报价</button>
              <button class="btn btn-primary" v-if="item.isSend==1" @click="sendInquiry">
                <i class="fas fa-undo-alt"></i> 撤回</button>
              <button class="btn btn-primary" v-else @click="sendInquiry"><i class="fas fa-paper-plane"></i> 发送报价</button>
            </div>

            <!-- 报价表格: 房型明细 -->
            <table class="quote-table">
              <thead>
                <tr>
                  <th>产品名称</th>
                  <th>使用时间</th>
                  <th>数量</th>
                  <th>成本单价</th>
                  <th>成本小计</th>
                  <th>报价单价</th>
                  <th>报价小计</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tt,index) in budgetDetail.budgetList" :key="index">
                  <td><span class="room-tag">{{ tt.productName }}</span></td>
                  <td>{{tt.stayDateStr}}</td>
                  <td>{{tt.stockNumber}}</td>
                  <td>{{tt.currency}}{{tt.stockPrice}}</td>
                  <td>{{tt.currency}}{{tt.stockPrice*tt.stockNumber}}</td>
                  <td v-if="item.isSend==1">{{tt.currency}}{{tt.ratio }}</td>
                  <td v-else>{{tt.currency}}
                    <el-input type="number" class="price-input" style="width:100px;" v-model="tt.ratio"/></td>
                  <td>{{tt.currency}}{{(tt.ratio*tt.stockNumber).toFixed(2)}}</td>
                </tr>
                
                <!-- <tr style="border-top: 2px solid #dbe4ed;">
                  <td colspan="5" style="text-align: right; font-weight: 700;">总计 (含税/服务费)</td>
                  <td style="font-weight: 700;">¥450 / ¥600</td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <div v-show="showInquiry" >
          <div style="display: flex;">
            <div class="inquiry-detail-card">
              <div class="trip-header">
                <div>
                  <h3 style="font-size: 20px;color: #142433; margin-bottom: 12px;">酒店询价</h3>
                  <div class="client-info"><i class="far fa-user"></i> {{ item.createName }} · 提出时间 {{ dateFormatYMDHM(item.createTime,"-") }}</div>
                </div>
                <div><span class="status-sent">{{ item.isSend==1?"已发送报价给客户":item.isSend==1&&isOrder==1?"客户已购买":"已撤回报价"}}</span></div>
              </div>      
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 24px;">
                <div>
                  <div style="margin-bottom: 18px;"><strong>人数：</strong>{{ item.peopleNumber }}</div>
                  <div style="margin-bottom: 18px;"><strong>行程：</strong>
                    <span v-for="(item2,index) in item.planInfo" :key="index">{{item2 }}
                      <span v-if="item.planInfo&&index!=(item.planInfo.length-1)"> · </span></span></div>
                  <div><strong>需求：</strong><span v-for="(item2,index) in item.needDetail" :key="index">{{item2 }}
                      <span v-if="item.needDetail&&index!=(item.needDetail.length-1)"> · </span></span></div>
                </div>
              </div>
              <div class="budget-box">
                <div style="font-weight: 600; margin-bottom: 14px;">预算明细</div>
                <div class="room-locked">
                  <div class="room-tag" v-for="(item1,index) in item.hotelRoomList" :key="index">
                    <span>{{ item1.hotelRoomName }} · {{item1.roomNumber}}间&nbsp;&nbsp;</span>
                    <span>锁死预算 {{item.currency}}{{item.roomBudget}}/间/晚</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="record-container">
              <!-- 标题栏，只显示操作记录与询单编号 -->
              <div class="record-header">
                <h2>操作记录</h2>
              </div>
              <div class="record-list">
                <div class="record-item" v-for="(item1,index) in item.oprationLogs" :key="index">
                  <div class="record-top">
                    <span class="operator">{{ item1.createName }}</span>
                    <span class="record-time">{{ dateFormatYMDHMS(item1.createTime,'-') }}</span>
                  </div>
                  <div class="record-meta">
                    <span class="meta-item">{{ item1.oprationContent }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getBudgetInfo} from '../../js/function'
import inquiryInfo from '../../rightPopup/inquiry/inquiryInfo.vue'
import Api from '@/components/Api/index.js'
import PlanApi from '@/components/Api/PlanApi.js'
export default{
  data(){
    return{
      item:{},
      dialogVisible:false,
      isOrder:false,
      showInquiry:true,
      budget:{},
      budgetDetail:{},
    }
  },
  methods:{
    saveQutation(){
      new PlanApi('plan').updateBudgetDetail({
        id:this.budget.budgetMainId,
        details:this.budgetDetail.budgetList
      }).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"保存成功"})
          //重新计算合计金额
          this.loadQuationDetail()
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    loadQuationDetail(){
      new PlanApi('plan').oneBudgetDetailList({
        budgetMainId:this.budget.budgetMainId,
        state:this.budget.state,
        resourceId:this.budget.resourceId,
        productType:this.budget.productType,
      }).then(res => {
        if (res.status == 200) {
          this.budgetDetail = res.data
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    beforeOpen(inquiryId,isSend,isOrder,budget,showInquiry){
      this.dialogVisible = true
      this.isOrder = isOrder
      this.budget = budget
      this.showInquiry = showInquiry
      new Api('plan').inquiryDetail({ inquiryId: inquiryId}).then(res => {
        if (res.status == 200) {
          this.item = res.data
          this.$set(this.item,'isSend',isSend)
        } else {
          this.$message({ type: "error", message: res.statusText })
        }
      })
      this.loadQuationDetail()
    },
    sendInquiry(){
      var stockIds = this.budgetDetail.budgetList.map(ee=>ee.stockId);
      if(this.item.isSend==1){
        new Api('plan').canclePrice({ inquiryId: this.item.inquiryId,stockIds:stockIds}).then(res => {
          if (res.status == 200) {
            this.$message({ type: "success", message: "撤回成功" })
            this.$set(this.item,'isSend',0)
            getBudgetInfo(this.$store.state.budgetMainId)
          } else {
            this.$message({ type: "error", message: res.statusText })
          }
        })
      }else{
        new Api('plan').sendPrice({ inquiryId: this.item.inquiryId,stockIds:stockIds}).then(res => {
          if (res.status == 200) {
            this.$message({ type: "success", message: "发送成功" })
            this.$set(this.item,'isSend',1)
            getBudgetInfo(this.$store.state.budgetMainId)
          } else {
            this.$message({ type: "error", message: res.statusText })
          }
        })
      }
     
    }
  },
  components:{inquiryInfo}
}
</script>
<style scoped lang="scss">
/deep/ .el-input__inner{
  border: none !important;
}
/* 可编辑输入框 */
.price-input {
  width: 100px;
  padding: 8px 12px;
  border: 1.5px solid #d0ddea;
  border-radius: 16px;
  font-size: 15px;
  font-weight: 500;
  color: #11212e;
  background: white;
  transition: 0.15s;
}
/* 询价详情卡片 (隐藏/显示由tab控制) */
.inquiry-detail-card {
  background: white;
  border-radius: 28px;
  padding: 28px;
  box-shadow: 0 16px 28px -6px rgba(0,20,50,0.05);
  border: 1px solid #eaf0f8;
  .trip-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .client-info {
    font-size: 15px;
    color: #2c3e50;
  }
  .budget-box {
    background: #f6f9ff;
    padding: 16px 20px;
    border-radius: 20px;
    margin: 18px 0;
  }
  .room-locked {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }
}
.main-area {
  flex: 2.2;
}
.status-sent {
  color: #1e7b48;
  background: #e1f3e8;
  padding: 4px 12px;
  border-radius: 30px;
  font-size: 13px;
}
/* 报价卡片 */
.quote-card {
  background: white;
  border-radius: 28px;
  padding: 20px 28px;
  box-shadow: 0 16px 28px -6px rgba(0,20,50,0.05);
  border: 1px solid #eaf0f8;
  margin-bottom: 20px;
  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cost-summary {
    display: flex;
    align-items: center;
    gap: 36px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    background: #f7faff;
    padding: 18px 24px;
    border-radius: 24px;
    .summary-item {
      display: flex;
      align-items: baseline;
      gap: 10px;
    }
    .summary-label {
      color: #4a627a;
      font-weight: 500;
    }
    .summary-value {
      font-size: 28px;
      font-weight: 700;
      color: #11212e;
    }
    .profit-badge {
      background: #e3f2e8;
      color: #1e7b48;
      padding: 6px 16px;
      border-radius: 40px;
      font-weight: 600;
      font-size: 15px;
    }
  }
  .action-group {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
  }
  .quote-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 12px;
  }
  .quote-table th {
    text-align: left;
    padding: 14px 8px 8px 0;
    font-weight: 600;
    color: #3d5770;
    font-size: 14px;
    border-bottom: 1px solid #e2eaf2;
  }

  .quote-table td {
    padding: 16px 8px 16px 0;
    border-bottom: 1px solid #eef3f9;
    color: #1f3449;
    font-weight: 500;
  }
  .room-tag {
    background: #e9f0fa;
    padding: 4px 12px;
    border-radius: 30px;
    font-size: 13px;
    color: #2a5caa;
  }
}  
/* 双Tab切换 */
.tab-container {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  border-bottom: 2px solid #e2eaf2;
}

.tab {
  padding: 10px 32px;
  font-size: 18px;
  font-weight: 600;
  color: #617e9c;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: 0.15s;
}

.tab.active1 {
  color: #1e88e5;
  border-bottom-color: #1e88e5;
}
.btn {
  padding: 7px 17px;
  border-radius: 40px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #d9e1ec;
  color: #2c3e50;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.02);
}
.btn-primary {
  background: #1e88e5;
  border-color: #1e88e5;
  color: white;
}
.record-container {
  width: 418px;
  margin-left: 20px;
  color: black;
    background: white;
    border-radius: 28px;
    padding: 0px 20px;
    box-shadow: 0 16px 30px -8px rgba(0, 20, 50, 0.06);
    border: 1px solid rgba(220, 230, 245, 0.6);
  }
 /* 标题区域 */
.record-header {
  margin-top: 20px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 20px;
  border-bottom: 1px solid #e6edf5;
  padding-bottom: 16px;
}
.record-header h2 {
  font-size: 18px;
  font-weight: 650;
  letter-spacing: -0.3px;
}
/* 记录列表 - 纯文本，无图标 */
.record-list {
  display: flex;
  flex-direction: column;
}
.record-item {
  padding: 5px 0;
  border-bottom: 1px solid #eff3f8;
}
/* 头部：操作人 + 时间 */
.record-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
}
.operator {
  font-weight: 650;
  font-size: 14px;
}
.record-time {
  font-size: 12px;
  font-weight: 500;
}
/* 元信息 / 标签行 */
.record-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 28px;
  font-size: 14px;
}
.meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>